import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';

export default function ZirveNovaSmsDialog({ visible, smsDescription, loading, onCancel, onVerify }) {
    const [smsCode, setSmsCode] = useState('');

    useEffect(() => {
        if (!visible) {
            setSmsCode('');
        }
    }, [visible]);

    const handleVerify = () => {
        if (smsCode.length === 6 && !loading) {
            onVerify(smsCode);
        }
    };

    const handleCancel = () => {
        setSmsCode('');
        onCancel();
    };

    return (
        <Dialog
            header="SMS Doğrulama"
            visible={visible}
            style={{ width: '400px', maxWidth: 'calc(100vw - 2rem)' }}
            modal
            closable={false}
            onHide={handleCancel}
            footer={
                <div className="flex justify-content-end gap-2">
                    <Button label="İptal" icon="pi pi-times" className="p-button-text" onClick={handleCancel} disabled={loading} />
                    <Button label="Doğrula" icon="pi pi-check" loading={loading} onClick={handleVerify} disabled={smsCode.length !== 6} />
                </div>
            }
        >
            <div className="flex flex-column gap-3">
                <p className="m-0">{smsDescription || 'Telefonunuza gönderilen 6 haneli doğrulama kodunu giriniz.'}</p>
                <div className="p-inputgroup">
                    <span className="p-inputgroup-addon">
                        <i className="pi pi-lock"></i>
                    </span>
                    <InputText
                        id="zirve-nova-sms-code"
                        aria-label="SMS doğrulama kodu"
                        value={smsCode}
                        onChange={(event) => setSmsCode(event.target.value.replace(/\D/g, '').slice(0, 6))}
                        onKeyDown={(event) => event.key === 'Enter' && handleVerify()}
                        placeholder="000000"
                        className="w-full text-center"
                        style={{ letterSpacing: '0.5rem', fontSize: '1.2rem' }}
                        maxLength={6}
                        inputMode="numeric"
                        autoComplete="one-time-code"
                        autoFocus
                    />
                </div>
            </div>
        </Dialog>
    );
}

